import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { erpPath } from '@/utils/erp-host';
import StudentProfile from './StudentProfile';

// Full-page student profile — mounted at /erp/students/:uuid.
const StudentProfilePage: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();

  if (!uuid) return null;

  // Prefer going back in history so the students list restores its exact
  // filtered/paged view; fall back to the list route on a direct/deep load.
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(erpPath('students'));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <button
        className="btn btn-ghost btn-sm"
        onClick={goBack}
        style={{ margin: '14px 24px 0', alignSelf: 'flex-start', gap: 6 }}
      >
        <ArrowLeft size={15} /> Back to Students
      </button>
      <div style={{ flex: 1, minHeight: 0 }}>
        <StudentProfile uuid={uuid} variant="page" />
      </div>
    </div>
  );
};

export default StudentProfilePage;
